import { COUNTRIES, ICountry } from "../constants/countries";
import { ISelectOption } from "../constants/types";

export const DEFAULT_COUNTRY_NAME = "India";

export const getCountryByName = (cname: string = DEFAULT_COUNTRY_NAME): ICountry => {
    const country  = COUNTRIES.find(({ name }) => name.trim().toLowerCase() === cname.trim().toLowerCase())
    return country ? country : COUNTRIES[0]
};

export const getDialCodeByCountry = (country: string = DEFAULT_COUNTRY_NAME): string => {
    return (COUNTRIES.find(({ name }) => name.toLowerCase() === country.trim().toLowerCase())?.dialCode ?? "+91");
};



//  eg: code = IN return INDIA object
export const getCountryByCode = (code: string): ICountry | undefined => {
    return COUNTRIES.find(
        (country) => country.code === code
    );
};

export const getCountriesByCurrency = (
    currencyCode: string
): ICountry[] => {
    return COUNTRIES.filter(
        (country) => country.currencyCode === currencyCode
    );
};


export const getCountryOptions = (): ISelectOption[] => {
    return COUNTRIES
        .filter((country) => country.isActive)
        .map((country) => ({
            label: `${country.flag} ${country.name}`,
            value: country.code,
        }));
};